import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Edit } from "lucide-react";
 * // Use <Edit /> instead
 */
export const EditIcon = createSVGWrapper(
  <>
    <path
      d="M18.4142 5.41422C17.6332 4.63317 16.3669 4.63317 15.5858 5.41422L14.3536 6.64643L17.8891 10.182L19.1213 8.94975C19.9024 8.1687 19.9024 6.90237 19.1213 6.12132L18.4142 5.41422Z"
      fill="currentColor"
    />
    <path
      d="M16.4749 11.5962L12.9394 8.06064L4.9792 16.0208L4.27209 20.2635L8.51474 19.5564L16.4749 11.5962Z"
      fill="currentColor"
    />
  </>
);
